import { faAngleDown, faDiagramSubtask, faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StatusTagEnum } from '@tryhackme/thm-ui-components';
import { useRef, useState } from 'react';
import { ContextType } from 'src/common/enums/categorization-dashboard';
import { ACCORDION_ANIMATION_DURATION } from 'src/features/manage-room/components/tasks-tab/components/task-accordion/task-accordion.constants';
import { useGetRuleQuery } from '../../categorization.slice';
import { Rule } from '../rule/rule';
import { ruleInitialValue } from '../rule/rule.constants';
import { StyledAccordionBody, StyledAccordionSummary, StyledAccordionWrapper, StyledButton, StyledCard, StyledChevronIcon, StyledIcon, StyledIconWrapper, StyledSummaryHeader, StyledTag, StyledTitle } from './accordion.styles';
import type { AccordionProps } from './accordion.types';
export const Accordion = ({
  id,
  title,
  type,
  index,
  sources,
  rooms,
  open,
  handleRemove
}: AccordionProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(open);
  const {
    data,
    isLoading
  } = useGetRuleQuery(id, {
    skip: !id || !isOpen
  });
  const rule = data?.data ?? ruleInitialValue;
  const handleClick = () => setIsOpen(!isOpen);
  const renderTag = () => {
    switch (type) {
      case ContextType.ATTACK_BOX:
        {
          return <StyledTag size="default" status={StatusTagEnum.RED}>
            Attack Box
          </StyledTag>;
        }
      case ContextType.ROOM:
        {
          return <StyledTag size="default" status={StatusTagEnum.BLUE}>
            Room Specific
          </StyledTag>;
        }
      case ContextType.HIBRID:
        {
          return <StyledTag size="default" status={StatusTagEnum.ORANGE}>
            Hybrid
          </StyledTag>;
        }
      default:
        {
          return <StyledTag size="default" status={StatusTagEnum.GREEN}>
            Generic
          </StyledTag>;
        }
    }
  };
  return <StyledAccordionWrapper data-sentry-element="StyledAccordionWrapper" data-sentry-component="Accordion" data-sentry-source-file="accordion.tsx">
      <StyledAccordionSummary role="button" aria-expanded={isOpen} data-sentry-element="StyledAccordionSummary" data-sentry-source-file="accordion.tsx">
        <StyledSummaryHeader onClick={handleClick} data-sentry-element="StyledSummaryHeader" data-sentry-source-file="accordion.tsx">
          <StyledIconWrapper data-sentry-element="StyledIconWrapper" data-sentry-source-file="accordion.tsx">
            <StyledIcon icon={faDiagramSubtask} data-sentry-element="StyledIcon" data-sentry-source-file="accordion.tsx" />
          </StyledIconWrapper>
          <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="accordion.tsx">
            {id && renderTag()}
            {title || 'Rule'}
          </StyledTitle>
        </StyledSummaryHeader>

        <StyledButton variant="outlined" color="secondary" size="small" onClick={() => handleRemove(id, index)} data-sentry-element="StyledButton" data-sentry-source-file="accordion.tsx">
          <FontAwesomeIcon icon={faTrashCan} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="accordion.tsx" />
          Remove
        </StyledButton>

        <StyledChevronIcon isOpen={isOpen} icon={faAngleDown} onClick={handleClick} data-sentry-element="StyledChevronIcon" data-sentry-source-file="accordion.tsx" />
      </StyledAccordionSummary>
      <StyledAccordionBody nodeRef={ref} in={isOpen} timeout={ACCORDION_ANIMATION_DURATION} unmountOnExit data-sentry-element="StyledAccordionBody" data-sentry-source-file="accordion.tsx">
        <StyledCard data-sentry-element="StyledCard" data-sentry-source-file="accordion.tsx">{!isLoading && <Rule sources={sources} rooms={rooms} rule={rule} />}</StyledCard>
      </StyledAccordionBody>
    </StyledAccordionWrapper>;
};